import BackgroundAnimation from '../components/BackgroundAnimation';

// images
import featured_detailed_img_1 from '../../assets/images/feature-detailed-img-1.jpg';
import featured_detailed_img_2 from '../../assets/images/feature-detailed-img-2.jpg';
import featured_detailed_img_3 from '../../assets/images/feature-detailed-img-3.jpg';

const feature_tab = [
    {
        icon: "las la-eye",
        title: "Matching anónimo y antisesgos",
        content: (
            <>
                <p className="bold">Porque el talento no tiene etiquetas</p>
                <p className='fw-normal'>¿Harto de que tu edad, género, raza o incluso ese “gap” de carrera decidan por ti antes de que tú puedas hablar? En Woowii hemos venido a jubilar a los ATS y sus sesgos. Adiós filtros injustos, hola AMS (Applicant Matching System): el futuro de la selección justa y humana.
                    </p>
                    <p className='fw-normal'>Nuestro matching anónimo elimina lo irrelevante (apellidos, fotos y prejuicios) para centrarse en lo que importa: tu talento, tus habilidades y esa historia que te hace irrepetible. Sin edadismo, sin castigos por parones laborales, sin etiquetas de género, sexualidad o maternidad.</p>
                <br></br>
                <p className="bold">💡 Así lo hacemos: </p>
                <p className='fw-normal'>Empresas y candidatos se encuentran en una conexión auténtica y bidireccional. Nada de CVs jurásicos ni de perfiles maquillados. Solo datos reales y relevantes que garantizan el match perfecto.</p>
                <br></br>
                <p className="bold mb-0">🚀 Por qué funciona:</p>
                <p className='fw-normal mb-0'><strong>✔️ Empresas:</strong> Descubren talento que rompe moldes, no sesos.</p>
                <p className='fw-normal mb-0'><strong>✔️ Candidatos:</strong> Tienen por fin una oportunidad justa para demostrar todo lo que valen.</p>
                <br></br>
                <p className='fw-normal'>🤝 Cambiamos las reglas del juego. Ya no se trata de encontrar al “mejor CV”, sino a la persona que realmente encaja. Porque el talento no discrimina, y nosotros tampoco.</p>
                <br></br>
                <p className='fw-normal'>🌟 Es hora de jubilar los ATS y dar paso al AMS. Bienvenido al futuro de la selección. ¿A qué esperas? Apúntate ya.</p>
            </>
        )
    },
    {
        icon: "las la-sync-alt",
        title: "Algoritmo Bi-direccional",
        content: (
            <>
                <p className="bold">🤖 Aquí no hay swipes, solo ciencia y sentido común.</p>
                <p className='fw-normal'>¿Izquierda o derecha? ¿Qué es esto, una aplicación de ligues del 2010? En Woowii, el matching no se deja al azar ni a juicios rápidos de un dedo aburrido. Nuestro sistema bidireccional de verdad analiza lo que ambas partes aportan a la mesa: candidatos y empresas completan sus perfiles con datos reales, relevantes y humanos, y nuestro algoritmo hace la magia.</p>
                <br></br>
                <p className="bold">💡 ¿Cómo lo hacemos? </p>
                <p className='fw-normal'>Nuestro algoritmo propietario no usa LLM de terceros, con lo que conecta más allá del “me gusta” superficial:</p>
                <ul className='ml-3 woowii-ul'>
                    <li>
                    <strong>Empresas:</strong> Sabemos que buscas más que una lista de habilidades. Analizamos tu cultura, valores y necesidades reales para encontrar el talento ideal.
                    </li>
                    <li>
                    <strong>Candidatos:</strong> Eres mucho más que un CV. Tus competencias transversales, tus logros y hasta tu historia cuentan para hacer el match perfecto.
                    </li>
                </ul>
                <br></br>
                <p className="bold mb-0">🚀 ¿Qué nos diferencia?</p>
                <p className='fw-normal mb-0'><strong>✔️ Matching profundo:</strong> No se trata solo de encajar, sino de pertenecer.</p>
                <p className='fw-normal mb-0'><strong>✔️ Bidireccional de verdad:</strong> Ambos tienen voz, y ambos tienen el poder de elegir.</p>
                <p className='fw-normal'><strong>✔️ Humanidad y datos:</strong> Una mezcla perfecta de storytelling y tecnología para que el match no solo funcione, sino que perdure.</p>

                <br></br>
                <p className='fw-normal'><strong>🔮 Resultado:</strong> Menos ghosting, menos rotación después de la contratación, más conexiones reales, y ese momento de: "¡por fin encontré lo que buscaba!" para ambas partes.</p>


                <br></br>
                <p className="bold">✨ Olvídate del swipe sin sentido.</p>
                <p className='fw-normal'>El futuro del matching es personal, analítico y con corazón. Bienvenido al único sistema bidireccional que piensa antes de conectar: Bienvenidos a Woowii.</p>
            </>
        )
    },
    {
        icon: "lab la-wpforms",
        title: "Assessment Woowii",
        content: (
            <>
                <p className="bold">🧠  Más que un test, es tu pasaporte al match perfecto.</p>
                <p className='fw-normal'>Olvídate de cualquier test genérico de los 90's. En Woowii jugamos en otra liga. Nuestro assessment exclusivo no te encasilla en categorías anticuadas ni te pregunta si prefieres gatos o perros. Fue creado por nuestro equipo expertos en psicología y comportamiento humano para una cosa: revelar lo mejor de ti y hacerlo brillar en nuestro algoritmo.</p>
                <br></br>
                <p className="bold">💡 ¿Qué mide nuestro assessment? </p>
                <p className='fw-normal'><strong>✔️ Competencias transversales:</strong> Eso que te hace destacar en cualquier equipo, desde la comunicación hasta tu capacidad de liderazgo.</p>
                <p className='fw-normal'><strong>✔️ Hard y soft skills: </strong> Porque tu conocimiento técnico es tan importante como tu creatividad para resolver problemas.</p>
                <p className='fw-normal'><strong>✔️ Tu historia:</strong> No es un test más, es una forma de contar quién eres y qué puedes aportar.</p>
                
                <br></br>
                <p className="bold mb-0">🚀 ¿Por qué es diferente?</p>
                <p className='fw-normal mb-0'>Mientras otros assessments son "copy-paste" del mercado, el nuestro está diseñado a medida para nuestro sistema. Tus resultados no se quedan en un informe bonito que nadie lee; alimentan directamente nuestro algoritmo para que el match sea tan preciso como un rayo láser.</p>

                <br></br>
                <p className="bold mb-0">🔍 ¿Qué ganas?</p>
                <p className='fw-normal mb-0'><strong>✔️ Candidatos:</strong> Más que un número, te conviertes en un perfil único y atractivo para las empresas.</p>
                <p className='fw-normal'><strong>✔️ Empresas:</strong> Una visión completa del candidato, más allá del CV y los títulos.</p>
                <p className='fw-normal'>✨ Aquí no hay etiquetas, solo potencial puro. Nuestro assessment es la pieza clave que conecta tus capacidades con las oportunidades ideales. Porque el talento se mide de verdad, no con test de personalidad obsoletos.</p>

                <br></br>
                <p className="bold">Woowii: redefiniendo el assessment, revolucionando el matching.</p>

            </>
        )
    },
    {
        icon: "las la-history",
        title: "Reducción en costo de Selección",
        replaceTitle: "Ahorra tiempo, dinero y neuronas",
        content: (
            <>
            <p className="bold">⏳ Reducción de tiempo y costes: </p>
            <p className='fw-normal'>Más onboarding, menos dolores de cabeza ¿Te suena eso de invertir semanas en entrevistas para descubrir algo que podrías haber sabido en 5 minutos? Spoiler alert: En Woowii, ese tiempo ya no se pierde. Sí, nuestro onboarding toma un poco más de tiempo (lo admitimos). Pero no es un trámite aburrido, es una inversión estratégica. Candidatos y empresas completan información tan relevante que la mayoría de los datos que antes salían en una primera llamada o incluso en entrevistas posteriores ya están listos desde el primer “match”.</p>
            
            <br></br>
            <p className="bold">💡 ¿Por qué funciona?</p>
            <p className='fw-normal'><strong>✔️ Candidatos:</strong> Olvídate de repetir lo mismo 10 veces. Lo que compartes aquí llega directamente a las empresas que de verdad valoran tu perfil.</p>
            <p className='fw-normal'><strong>✔️ Empresas:</strong> Nada de perder horas filtrando CVs irrelevantes o haciendo preguntas básicas. Desde el principio sabes quién encaja y por qué.</p>


            <br></br>
            <p className="bold">🚀 Beneficios que se sienten en el bolsillo:</p>
            <ul className='ml-3 woowii-ul'>
                <li>
                <strong>Posiciones abiertas menos tiempo:</strong> Menos días en el mercado, más productividad para tu equipo.
                </li>
                <li>
                <strong>Adiós llamadas innecesarias:</strong> Con nuestra triangulación de datos y assessment, las dudas básicas ya vienen resueltas.
                </li>
                <li>
                <strong>Optimización real:</strong> Más precisión, menos recursos malgastados, y lo mejor de todo... más tiempo para lo que importa: contratar talento excepcional.
                </li>
            </ul>

            <br></br>
            <p className='fw-normal mb-0'>🌟 Con Woowii, invertirás tiempo al principio, pero ahorrarás semanas (y dolores de cabeza) después. Porque el mejor match no solo es más rápido, también es más eficiente.</p>

            <br></br>
            <p className='fw-normal mb-0'>📌 <strong>Bienvenido al nuevo estándar de selección:</strong> rápido, inteligente y rentable.</p>
        </>
        )
    },
    {
        icon: "las la-filter",
        title: "Historias en lugar de CV",
        content: (
            <>
            <p className="bold">Porque tu talento no cabe en una hoja A4</p>
            <p className='fw-normal'>¿Un CV? ¿De verdad en 2024 seguimos confiando en Times New Roman para vender todo lo que eres? En Woowii, el CV tradicional es cosa del pasado. Aquí tu experiencia no se limita a fechas y bullet points aburridos; se convierte en una historia que conecta.</p>
    
            <br></br>
            <p className="bold mb-0">💡 ¿Por qué historias?</p>
            <p className='fw-normal mb-0'><strong>✔️ Para los candidatos:</strong> Tu recorrido profesional tiene alma, aprendizajes y momentos claves que no se reflejan en un título universitario. Cuéntanos cómo superaste retos, cómo creaste impacto, y qué te mueve.</p>
            <p className='fw-normal mb-0'><strong>✔️ Para las empresas:</strong> Porque saber que alguien trabajó “X años en Y empresa” no dice nada sobre su pasión, valores o capacidades. Con nuestras historias, descubres a la persona detrás del perfil.</p>
    
            <br></br>
            <p className="bold mb-0">🚀 ¿Cómo lo hacemos?</p>
            <p className='fw-normal mb-0'><strong>✔️ Candidatos:</strong> Completa tu historia en formato interactivo. Desde tus “superpoderes” hasta esos momentos que marcaron tu trayectoria.</p>
            <p className='fw-normal mb-0'><strong>✔️ Empresas:</strong> Publica historias de tu cultura, liderazgo y visión para conectar con quienes realmente encajan contigo.</p>
            
            <br></br>
            <p className="bold mb-0">🌟 El resultado:</p>

            <p className='fw-normal'><strong>✔️ Conexión auténtica:</strong> Empresas y candidatos encuentran puntos en común más allá de las credenciales.</p>
            <p className='fw-normal'><strong>✔️ Proceso más humano:</strong> Las historias hacen que ambos lados se vean como lo que son: personas con valores y aspiraciones.</p>
            <p className='fw-normal'><strong>✔️ El match perfecto:</strong> Porque un buen fit no está en un párrafo frío, sino en una narrativa que inspira. <br></br>📌 En Woowii no creamos CVs, contamos historias. Porque una buena historia vale más que mil títulos. ¿Listo para dejar de ser una hoja de papel?</p>
        </>
        )
    },
    {
        icon: "las la-brain",
        title: "La IA que sí entiende de personas",
        replaceTitle: "Woowii: La IA que sí entiende de personas (y regula su impacto)",
        content: (
            <>
                <p className='fw-normal'>En un mundo donde todo el mundo promete IA revolucionaria pero termina usando modelos genéricos de terceros, Woowii marca la diferencia. Nuestra plataforma no solo es inteligente, inclusiva y ética, sino que está diseñada para cumplir con las regulaciones más exigentes, como el AI Act europeo.</p>

                <br></br>
                <p className="bold">💡<strong>¿Por qué somos únicos?</strong> </p>
                <p className='fw-normal mb-0'><strong>✔️ Algoritmo propio:</strong> Creamos y entrenamos nuestra IA con datasets propios, ajustados a nuestras necesidades. ¿El resultado? Una tecnología precisa, responsable y libre de los sesgos heredados de otros sistemas.</p>
                <p className='fw-normal mb-0'><strong>✔️ Diseñada para el impacto social:</strong> Ayudamos a los colectivos más afectados por prejuicios—parados de larga duración, mayores de 40, jóvenes sin experiencia, mujeres con hijos, entre otros—a recuperar su lugar en el mercado laboral.</p>
                <p className='fw-normal mb-0'><strong>✔️ Sostenibilidad e innovación:</strong> Una IA que no solo revoluciona la selección, sino que lo hace respetando el medio ambiente y optimizando recursos. </p>

                <br></br>
                <p className="bold"><strong>🌟 Con Woowii obtienes:</strong></p>
                <ul class="woowii-ul">
                    <li>
                        <strong>Inclusión real: </strong>Eliminamos barreras, no creamos nuevas. Nuestra IA entiende el valor más allá de etiquetas superficiales.
                    </li>
                    <li>
                        <strong>Robustez y legalidad: </strong> Cumplimos con los estándares europeos de ética y sostenibilidad.
                    </li>
                    <li>
                        <strong>Humanidad y eficiencia: </strong> Nuestra plataforma no deshumaniza, sino que potencia el talento.
                    </li>
                </ul>

                <br></br>
                <p className="bold">🚀 Más allá de los CVs y LLMs genéricos:</p>
                <p className='fw-normal mb-0'> En Woowii no usamos un "copia-pega" de tecnologías preexistentes. Hemos desarrollado una solución que prioriza lo que realmente importa: la conexión auténtica entre empresas y candidatos, basada en datos sólidos y valores compartidos.</p>


                <br></br>
                <p className="bold">📌 Nuestro compromiso:</p>
                <p className='fw-normal mb-0'>Ser pioneros en tecnología que no solo funcione, sino que marque la diferencia en vidas reales. Porque creemos que la innovación debe ser responsable, inclusiva y, sobre todo, humana. ¿Listo para unirte al cambio? </p>

            </>
        )
    }
];

export default feature_tab;